module.exports = __webpack_public_path__ + "static/media/SleeveLED.fbe18ecb.jpeg";